import { render, staticRenderFns } from "./FeaturesTable.vue?vue&type=template&id=61c9e69c&scoped=true&"
import script from "./FeaturesTable.vue?vue&type=script&lang=js&"
export * from "./FeaturesTable.vue?vue&type=script&lang=js&"
import style0 from "./FeaturesTable.vue?vue&type=style&index=0&id=61c9e69c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c9e69c",
  null
  
)

export default component.exports